import SanityCta from "./SanityCta"
import SanityNavItem from "./SanityNavItem"

export const AtomComponents = {
  cta: SanityCta,
  navItem: SanityNavItem,
}
